/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".initials[_ngcontent-%COMP%]{width:70px;height:70px;border-radius:50%;border:3px solid #004e9b;font-weight:400;font-size:2.4rem;margin:0 auto}"];
export { styles as styles };
